var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7711)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#EE343C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3864 4.38646C12.1617 4.16175 11.8096 4.12689 11.5452 4.30316L10.9558 4.6961C10.5299 4.98004 10.5696 5.61817 11.0274 5.84709L12.2981 6.4824C12.5239 6.59533 12.6666 6.82617 12.6666 7.07869V7.33333C12.6666 7.70152 12.3681 8 11.9999 8H11.4906C11.3871 8 11.2851 7.9759 11.1925 7.92962L9.09636 6.88156C8.8397 6.75323 8.52972 6.80353 8.32682 7.00644L7.98729 7.34596C7.66553 7.66772 7.75355 8.21015 8.16055 8.41365L9.10449 8.88562C9.50348 9.08511 9.5381 9.64121 9.16694 9.88865C8.73628 10.1758 8.86773 10.8402 9.37527 10.9417L9.93721 11.0541C10.4767 11.162 10.6345 11.8574 10.1943 12.1875L9.69121 12.5649C9.36298 12.811 9.53708 13.3333 9.94736 13.3333C9.98227 13.3333 10.017 13.3291 10.0509 13.3206L11.3127 13.0051C11.7911 12.8855 12.166 13.4175 11.8925 13.8278C11.6534 14.1864 11.9105 14.6667 12.3414 14.6667H12.9249C13.1688 14.6667 13.3853 14.8227 13.4624 15.0541C13.6346 15.5707 14.3653 15.5707 14.5374 15.0541C14.6146 14.8227 14.8311 14.6667 15.075 14.6667H15.6585C16.0894 14.6667 16.3464 14.1864 16.1074 13.8278C15.8338 13.4175 16.2087 12.8855 16.6872 13.0051L17.9489 13.3206C17.9828 13.3291 18.0176 13.3333 18.0525 13.3333C18.4628 13.3333 18.6369 12.811 18.3086 12.5649L17.8055 12.1875C17.3654 11.8574 17.5231 11.162 18.0626 11.0541L18.6246 10.9417C19.1321 10.8402 19.2636 10.1758 18.8329 9.88865C18.4617 9.64121 18.4964 9.08511 18.8953 8.88562L19.8393 8.41365C20.2463 8.21015 20.3343 7.66772 20.0125 7.34596L19.673 7.00644C19.4701 6.80353 19.1601 6.75323 18.9035 6.88156L16.8073 7.92962C16.7148 7.9759 16.6127 8 16.5092 8H15.9999C15.6317 8 15.3333 7.70152 15.3333 7.33333V7.07869C15.3333 6.82617 15.4759 6.59534 15.7018 6.48242C16.0943 6.28612 16.562 6.05229 16.9726 5.84697C17.4305 5.61805 17.47 4.98004 17.0441 4.6961L16.4547 4.30316C16.1902 4.12689 15.8382 4.16175 15.6135 4.38646L14.4713 5.5286C14.211 5.78895 13.7889 5.78894 13.5285 5.5286L12.3864 4.38646Z",
    fill: "#262626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7711"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryAl);
export default __webpack_public_path__ + "static/media/Country=AL.9cd92f51c474274aa07da4ff04e82768.svg";
export { ForwardRef as ReactComponent };